// removed by extract-text-webpack-plugin
module.exports = {"block":"display__block___37v4_ display-block","inline":"display__inline___12Rem display-inline","inlineBlock":"display__inlineBlock___1bOR3 display-inlineBlock"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-max-width/MaxWidth/style/display.css
// module id = 200
// module chunks = 0 33